import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
// Finishes the SSO sign-in when the hosted UI sends the browser back with a code.
import 'aws-amplify/auth/enable-oauth-listener';
import { sessionStorage } from 'aws-amplify/utils';
import { SSO_SIGN_IN_ENABLED } from '../features';

// Injected at build time by SST via `ng build --define` (see sst.config.ts).
declare const COGNITO_USER_POOL_ID: string | undefined;
declare const COGNITO_CLIENT_ID: string | undefined;
declare const COGNITO_DOMAIN: string | undefined;

/** Where the hosted UI sends the browser back to, after sign-in and sign-out (sst.config.ts). */
export const AUTH_REDIRECT_PATH = '/login';

export function configureAuth(): void {
  const userPoolId = typeof COGNITO_USER_POOL_ID === 'undefined' ? '' : COGNITO_USER_POOL_ID;
  const userPoolClientId = typeof COGNITO_CLIENT_ID === 'undefined' ? '' : COGNITO_CLIENT_ID;
  const domain = typeof COGNITO_DOMAIN === 'undefined' ? '' : COGNITO_DOMAIN;

  if (!userPoolId || !userPoolClientId || (SSO_SIGN_IN_ENABLED && !domain)) {
    console.error('Cognito is not configured. Run the app with `pnpm dev` (sst dev).');
  }

  const redirect = [`${location.origin}${AUTH_REDIRECT_PATH}`];
  // Tokens are dropped when the tab is closed. Set before configure(), which may already finish
  // an SSO sign-in and store its tokens.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        // The hosted UI (OAuth) only exists when SSO is on (sst.config.ts).
        ...(SSO_SIGN_IN_ENABLED && {
          loginWith: {
            oauth: {
              domain,
              scopes: ['openid', 'email', 'aws.cognito.signin.user.admin'],
              redirectSignIn: redirect,
              redirectSignOut: redirect,
              responseType: 'code' as const,
            },
          },
        }),
      },
    },
  });
}
